import { createGlobalStyle } from "styled-components";
import tomicaFontBold from "./../assets/fonts/Tomica-Bold/Tomica-Bold.ttf";
import tomicaFontNormal from "./../assets/fonts/Tomica/Tomica.ttf";

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family:"Tomica";
        src: url(${tomicaFontNormal}) format("truetype");
        font-weight:normal;
    }

    @font-face{
        font-family:"Tomica";
        src:url(${tomicaFontBold}) format("truetype");
        font-weight:bold;
    }

    @font-face{
        font-family:"Tomica";
        src: url("//db.onlinewebfonts.com/t/e280bead88c9409dfc805618ee9c27bc.ttf") format("truetype");
        font-weight:900;
    }

    *,*::before,*::after{
        box-sizing: border-box;
        padding: 0;
        margin: 0;
    }

    html{
        font-size:10px;

        @media screen and (max-width:1250px){
            font-size:9px;
        }

    }

    body{
        background-color: ${({ theme }) => theme.colors.pink};
        width:100%;
        min-height: 100vh;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6{
        font-family:${({ theme }) => theme.ff.Tomica};
    }

    h1{
        font-size:${({ theme }) => theme.fz.XXL};
        font-weight:${({ theme }) => theme.fw.bold};

        &.big{
            font-size:${({ theme }) => theme.fz.XXXL};
        }

        &.center{
            text-align:center;
        }
    }
    h2{
        font-size:${({ theme }) => theme.fz.XL};
    }
    h3{
        font-size:${({ theme }) => theme.fz.L};
    }
    h4{
        font-size:${({ theme }) => theme.fz.M};
    }
    h5{
        font-size:${({ theme }) => theme.fz.S};
    }
    h6{
        font-size:${({ theme }) => theme.fz.XS};
    }

    p{
        font-size:${({ theme }) => theme.fz.XS};
        font-family:${({ theme }) => theme.ff.Tomica};
    }

    a{
        &:visited{
            color:${({ theme }) => theme.colors.black};
        }
    }

/* Page transition styles - smooth transitions without flickering */
.page {
    position: relative;
    width: 100%;
    min-height: 100vh;
}

/* Prevent scroll jumping during transitions */
html, body {
    overflow-x: hidden;
}

`;

const GlobalStyleComponent = (props) => <GlobalStyle />;

export default GlobalStyleComponent;
